<dx-html-editor
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(value)"
    [placeholder]="placeholder"
    [readOnly]="readOnly"
    [height]="height"
    [style.max-height]="maxHeight">
    <dxo-toolbar *ngIf="!readOnly">
        <dxi-item formatName="undo"></dxi-item>
        <dxi-item formatName="redo"></dxi-item>
        <dxi-item formatName="separator"></dxi-item>
        <dxi-item formatName="header" [formatValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
        <dxi-item formatName="separator"></dxi-item>
        <dxi-item formatName="bold"></dxi-item>
        <dxi-item formatName="italic"></dxi-item>
        <dxi-item formatName="strike"></dxi-item>
        <dxi-item formatName="underline"></dxi-item>
        <dxi-item formatName="separator"></dxi-item>
        <dxi-item formatName="alignLeft"></dxi-item>
        <dxi-item formatName="alignCenter"></dxi-item>
        <dxi-item formatName="alignRight"></dxi-item>
        <dxi-item formatName="alignJustify"></dxi-item>
    </dxo-toolbar>
    <dxo-media-resizing [enabled]=true></dxo-media-resizing>
</dx-html-editor>
